/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/path-dark': {
    width: 16,
    height: 21,
    viewBox: '0 0 16 21',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M0 7.44C0 3.339 3.38 0 7.533 0c4.154 0 7.534 3.338 7.534 7.44 0 5.093-6.742 12.567-7.029 12.883a.684.684 0 01-1.01 0C6.743 20.007 0 12.533 0 7.441zm4.109.093a3.428 3.428 0 003.424 3.424 3.428 3.428 0 003.424-3.424A3.428 3.428 0 007.533 4.11 3.428 3.428 0 004.11 7.533z" _fill="#000"/>'
  }
})
